<script>
    import { onMount } from "svelte";
  
    let isLoading = false;
    let clinicalNotes = "The patient has a history of hypertension for 12 years, currently managed with lisinopril. Labs from last visit showed an eGFR of 50, indicating stage 3 chronic kidney disease.";
    let responseText = ""; // Holds streamed response
    let finalCodes = [
      "I10 - Essential (primary) hypertension",
      "N18.3 - Chronic kidney disease, stage 3 (moderate)",
      "Z79.52 - Long term (current) use of angiotensin converting enzyme (ACE) inhibitors"
    ];
  
    const simulatedResponse = [
      "🔍 Analyzing patient notes...",
      "🩺 Identifying relevant medical conditions...",
      "📊 Matching conditions with ICD-10 codes...",
      "✅ I10 - Essential (primary) hypertension",
      "✅ N18.3 - Chronic kidney disease, stage 3 (moderate)",
      "✅ Z79.52 - Long term (current) use of angiotensin converting enzyme (ACE) inhibitors"
    ];
  
    async function handleSend() {
      if (isLoading) return;
      isLoading = true;
      responseText = ""; // Reset output
  
      for (let i = 0; i < simulatedResponse.length; i++) {
        await new Promise(resolve => setTimeout(resolve, 1000)); // Simulates AI delay
        responseText += simulatedResponse[i] + "\n"; // Stream response
      }
  
      isLoading = false;
    }
  </script>
  
  <style>
    .output-container {
      background: #1e1e1e; /* Dark theme */
      color: #ffffff;
      padding: 1rem;
      border-radius: 8px;
      margin-top: 1rem;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
      font-family: monospace;
      white-space: pre-line; /* Keeps line breaks */
      min-height: 250px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .final-codes {
      background: #ffffff;
      color: #000000;
      padding: 1rem;
      border-radius: 8px;
      margin-top: 1rem;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      font-family: monospace;
    }
    .welcome-screen {
      text-align: center;
    }
    .input-box {
      background: #f8f9fa;
      border-radius: 12px;
      padding: 1rem;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
  </style>
  
  <div class="container mt-5">
    <div class="row">
      
      <!-- Left Side - HippoCode Input Box -->
      <div class="col-md-6">
        <div class="welcome-screen">
          <img src="static/images/hippocode.png" alt="Hippocode Logo" class="img-fluid" style="max-width: 50px;" />
          <h2 class="mt-3">Welcome to HippoCode</h2>
          <p class="text-muted">Enter your clinical notes to automatically generate medical codes.</p>
  
          <!-- Large Input Styled Box -->
          <div class="input-box">
            <textarea class="form-control" rows="6" disabled>{clinicalNotes}</textarea>
          </div>
  
          <button class="btn btn-primary mt-3" on:click={handleSend} disabled={isLoading}>
            {isLoading ? "Processing..." : "Generate Codes"}
          </button>
        </div>
      </div>
  
      <!-- Right Side - Output Container -->
      <div class="col-md-6">
        <h5>Generated Medical Codes</h5>
        {#if responseText}
          <div class="output-container">
            {responseText}
          </div>
        {/if}
  
        {#if !isLoading && responseText}
          <div class="final-codes">
            {#each finalCodes as code}
              <div>{code}</div>
            {/each}
          </div>
        {/if}
      </div>
  
    </div>
  </div>
  